import { render, staticRenderFns } from "./AbilitiesView.vue?vue&type=template&id=74832957&scoped=true"
import script from "./AbilitiesView.vue?vue&type=script&lang=js"
export * from "./AbilitiesView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74832957",
  null
  
)

export default component.exports